import { lazyLoad } from "./helpers/Functions";
import { BlankString, MenuId, Roles } from "./Constants";
import Login from "./components/pages/Login";
import IMenu from "./components/pages/models/interfaces/IMenu";
import FormsAndDocuments from "./components/pages/admin/Forms&Documents";
import Home from "./components/pages/Home";
import ForgotPassword from "./components/pages/ForgotPassword";
import ResetPassword from "./components/pages/ResetPassword";
import RegistrationSuccess from "./components/pages/RegistrationSuccess";
import Videos from "./components/pages/Videos";
import AgentTools from "./components/pages/AgentTools";
import Productions from "./components/pages/Productions";
const Agents = lazyLoad("pages/admin/Agents");
const RegisterAgent = lazyLoad("pages/admin/RegisterAgent");
const Register = lazyLoad("pages/Register");
const Faqs = lazyLoad("pages/Faqs");
const Agent = lazyLoad("pages/Agent");
const Video = lazyLoad("pages/NewVideo");
const Links = lazyLoad("pages/Links");

const Menus: IMenu[] = [
    {
        id: MenuId.DASHBOARD,
        name: 'Dashboard',
        linkmenu: '/',
        defaultSubmenuId: 0,
        namesub: [],
        submenu: undefined,
        secure: true,
        component: Home,
        show: true,
        allowedRoles: undefined
    },
    {
        id: MenuId.RESOURCES,
        name: 'Resources',
        linkmenu: '/Documents',
        defaultSubmenuId: MenuId.FORMS_AND_DOCS,
        namesub: [
            {
                id: MenuId.FORMS_AND_DOCS,
                name: 'Forms & Documents',
                linkmenu: '/Documents',
                submenu: undefined,
                secure: true,
                component: FormsAndDocuments,
                show: true,
                allowedRoles: [Roles.ADMIN, Roles.AGENT, Roles.MANAGER]
            },
            {
                id: MenuId.TRAINING_VIDEOS,
                name: 'Training Videos',
                linkmenu: '/Videos',
                submenu: undefined,
                secure: true,
                component: Videos,
                show: true,
                allowedRoles: [Roles.AGENT, Roles.MANAGER, Roles.ADMIN]
            },
            {
                id: MenuId.TRAINING_VIDEOS,
                name: 'Links',
                linkmenu: '/Links',
                submenu: undefined,
                secure: true,
                component: Links,
                show: true,
                allowedRoles: [Roles.AGENT, Roles.MANAGER, Roles.ADMIN]
            }
        ],
        submenu: [],
        secure: true,
        allowedRoles: [Roles.ADMIN, Roles.AGENT, Roles.MANAGER],
        component: FormsAndDocuments,
        show: true
    },
    {
        id: MenuId.AGENTS,
        name: 'Brokers',
        linkmenu: '/Brokers',
        defaultSubmenuId: MenuId.AGENTS_LIST,
        namesub: [
            {
                id: MenuId.AGENTS_LIST,
                name: 'Broker Lists',
                linkmenu: '/Brokers',
                submenu: undefined,
                secure: true,
                component: Agents,
                show: true,
                allowedRoles: [Roles.MANAGER, Roles.ADMIN]
            },
            {
                id: MenuId.AGENTS_SEND_REGISTRATION,
                name: 'Send Registration',
                linkmenu: '/Brokers/SendRegistration',
                submenu: undefined,
                secure: true,
                component: RegisterAgent,
                show: true,
                allowedRoles: [Roles.ADMIN]
            },
            // {
            //     id: MenuId.PRODUCTIONS,
            //     name: 'Production',
            //     linkmenu: '/Agents/Productions',
            //     submenu: undefined,
            //     secure: true,
            //     component: Productions,
            //     show: false,
            //     allowedRoles: [Roles.AGENT, Roles.MANAGER, Roles.ADMIN]
            // },
        ],
        submenu: [],
        secure: true,
        allowedRoles: [Roles.AGENT, Roles.MANAGER, Roles.ADMIN],
        component: Agents,
        show: true
    },
    {
        id: MenuId.LOGIN,
        name: 'Login',
        linkmenu: '/Login',
        defaultSubmenuId: 0,
        namesub: [],
        submenu: undefined,
        secure: false,
        component: Login,
        show: true,
        allowedRoles: undefined
    },
    {
        id: MenuId.FORGOT_PASSWORD,
        name: BlankString,
        linkmenu: '/ForgotPassword',
        defaultSubmenuId: 0,
        namesub: [],
        submenu: undefined,
        secure: false,
        component: ForgotPassword,
        show: false,
        allowedRoles: undefined
    },
    {
        id: MenuId.RESET_PASSWORD,
        name: BlankString,
        linkmenu: '/ForgotPassword/Reset',
        defaultSubmenuId: 0,
        namesub: [],
        submenu: undefined,
        secure: false,
        component: ResetPassword,
        show: false,
        allowedRoles: undefined
    },
    // Commented out for next phase...ABS
    // {
    //     id: MenuId.AGENT_TOOLS,
    //     name: 'AGENT TOOLS',
    //     linkmenu: '/AgentTools',
    //     defaultSubmenuId: MenuId.PRODUCTIONS,
    //     namesub: [
    //     {
    //         id: MenuId.FNA,
    //         name: 'FNA',
    //         linkmenu: '/AgentTools/FNA',
    //         submenu: undefined,
    //         secure: true,
    //         component: RegisterAgent,
    //         show: true,
    //         allowedRoles: [Roles.ADMIN]
    //     }],
    //     submenu: undefined,
    //     secure: true,
    //     allowedRoles: [Roles.AGENT, Roles.MANAGER, Roles.ADMIN],
    //     component: AgentTools,
    //     show: true
    // },
    {
        id: MenuId.FAQ,
        name: 'FAQ',
        linkmenu: '/FAQ',
        defaultSubmenuId: 0,
        namesub: [],
        submenu: undefined,
        secure: true,
        allowedRoles: [Roles.AGENT, Roles.MANAGER, Roles.ADMIN],
        component: Faqs,
        show: true
    },
    {
        id: MenuId.REGISTER_TOKENID,
        name: BlankString,
        linkmenu: '/Register/:tokenId',
        defaultSubmenuId: 0,
        namesub: [],
        submenu: undefined,
        secure: false,
        component: Register,
        show: false,
        allowedRoles: undefined
    },
    {
        id: MenuId.REGISTER_SUCCESS,
        name: BlankString,
        linkmenu: '/Register/Success',
        defaultSubmenuId: 0,
        namesub: [],
        submenu: undefined,
        secure: false,
        component: RegistrationSuccess,
        show: false,
        allowedRoles: undefined
    },
    {
        id: MenuId.AGENT_PROFILE,
        name: BlankString,
        linkmenu: '/Brokers/:agentId',
        defaultSubmenuId: 0,
        namesub: [],
        submenu: undefined,
        secure: true,
        component: Agent,
        show: false,
        allowedRoles: [Roles.ADMIN]
    },
    {
        id: MenuId.TRAINING_VIDEOS,
        name: BlankString,
        linkmenu: '/Videos/New',
        defaultSubmenuId: 0,
        namesub: [],
        submenu: undefined,
        secure: true,
        component: Video,
        show: false,
        allowedRoles: [Roles.ADMIN]
    }
]
export default Menus;